import React from "react";

const Bus = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="25.023"
    height="25.022"
    viewBox="0 0 25.023 25.022"
  >
    <g
      id="Group_57689"
      data-name="Group 57689"
      transform="translate(-845 -293)"
    >
      <path
        id="Path_36555"
        data-name="Path 36555"
        d="M34.988,32.7v1.031a.863.863,0,1,0,1.725,0c0-.263-.014-1.031-.014-1.031h1.14V26.585s-.313-3.1-.442-4.326c-.144-1.37-.461-1.77-1.424-2.224a10.613,10.613,0,0,0-4.562-.924,10.616,10.616,0,0,0-4.563.924c-.963.455-1.279.854-1.424,2.224-.13,1.23-.442,4.326-.442,4.326V32.7h1.14s-.014.768-.014,1.031a.863.863,0,1,0,1.725,0V32.7Zm-8.874-2.88a.859.859,0,1,1,.859.859.859.859,0,0,1-.859-.859m8.879,0a.859.859,0,1,1,.859.859.859.859,0,0,1-.859-.859m-6.234-8.762a.392.392,0,1,1,0-.783H34.1a.392.392,0,1,1,0,.783Zm-2.047,5.577A.577.577,0,0,1,26.127,26c.1-1.375.181-2.151.349-3.531a.612.612,0,0,1,.671-.506H35.69a.629.629,0,0,1,.671.529c.186,1.453.25,2.093.353,3.5a.554.554,0,0,1-.551.638Z"
        transform="translate(826.1 278.66)"
        fill="#1a1818"
      />
      <g
        id="Ellipse_528"
        data-name="Ellipse 528"
        transform="translate(845 293)"
        fill="none"
        stroke="#1a1818"
        strokeWidth="1"
      >
        <circle cx="12.511" cy="12.511" r="12.511" stroke="none" />
        <circle cx="12.511" cy="12.511" r="12.011" fill="none" />
      </g>
    </g>
  </svg>
);

export default Bus;
